module.exports = "/_next/static/images/c3c52ecc196536fbd6e84b74d3dbb5c8-lock-new.svg";